export default __webpack_public_path__ + "static/europe-uk-6b2c21e833c93e1094195aeb73ac0773.svg";